//https://www.youtube.com/watch?v=u3KlatzB7GM
import {createSlice} from "@reduxjs/toolkit";
import {useSelector} from "react-redux";

//  this showed how to create the reducer
// https://stackoverflow.com/questions/68971771/react-redux-toolkit-action-in-dispatch-returns-err-object-is-not-a-functi

export const workIssuanceSlice = createSlice({
    name: 'workIssuanceSlc',
    initialState: {value: {contractId: null, contractName: null,
            calcTabState: true,
            payTabState: false,

            owedGridState: true,
            obligationGridState: false,
            offsetsGridState: false,
            paymentGridState: false,
            fringeGridState: false,
            taxGridState: false,
            expenseGridState: false,
            requestGridState: false,

            owedAccrualGridState: false,
            obligationAccrualGridState: false,
            offsetsAccrualGridState: false,
            paymentAccrualGridState: false,
            fringeAccrualGridState: false,
            taxAccrualGridState: false,
            expenseAccrualGridState: false,
            requestAccrualGridState: false,

            owedLiabilityGridState: false,
            obligationLiabilityGridState: false,
            offsetsLiabilityGridState: false,
            paymentLiabilityGridState: false,
            fringeLiabilityGridState: false,
            taxLiabilityGridState: false,
            expenseLiabilityGridState: false,
            requestLiabilityGridState: false,

            owedUltimateGridState: false,
            obligationUltimateGridState: false,
            offsetsUltimateGridState: false,
            paymentUltimateGridState: false,
            fringeUltimateGridState: false,
            taxUltimateGridState: false,
            expenseUltimateGridState: false,
            requestUltimateGridState: false,
        confirmationGridState: false,

            obligationGridRefresh: false,
            offsetGridRefresh: false,
            owedGridRefresh: false,
            paymentGridRefresh: false,
            fringeGridRefresh: false,
            taxGridRefresh: false,
            expenseGridRefresh: false,

            cashState: true,
            accrualState: false,
            liabilityState: false,
            ultimatesState: false,

            clearData: false,

            calcSearchProductId: null,


            maxVersionNumber: null,



            paySearchProductId: null,
            payVersionNumber: null,

            versionNumber: null,
            versionMode: null,
            versionStatusId: null,
            versionStatusName: null,
            versionPeriodEndDate: null,
            testScenarioNumber : null,
            testScenarioName : null,
            testScenarioPropertyId : null,
            testScenarioPropertyName : null,
            showStats: false,

            fetchProductId: null,
            fetchVersionNumber: null,

            newStatus: null,
            updateCdpStatus: false,
        }},

    reducers:
        // {
        //     changeWorkIssuance: (state, action) => {
        //         state.value = action.payload;
        //     },
        // }
{
    changeWorkIssuance: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeWorkIssuance } = workIssuanceSlice.actions;

export default  workIssuanceSlice.reducer ;
